import React from 'react';
import moment from 'moment';

import { CirclePicker } from 'react-color';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import { updateEventForm } from '../../actions/eventForm';
import { createEvent } from '../../actions/events';

import Loading from '../layout/Loading';
import './event.scss';

const Event = ({ t, description, color, date, loading, onChange, onSubmit }) =>
  <Loading active={loading} text="loading">
    <form action="#" onSubmit={(e) => onSubmit(e, name, color)}>
      <div className="create-event-form">
        <div className="date-of-event">
          <label className="label-event">{t('DATE_OF_EVENT')}:</label>
          <b>{moment(new Date(date)).format("DD-MM-YYYY")}</b>
        </div>
        <div className="form-group">
          <label className="label-event" htmlFor="name">{t('NAME_OF_EVENT')}: </label>
          <input className="input-event" name="description" value={description} onChange={onChange} type="text" />
        </div>
        <div className="form-group">
          <label className="label-event" htmlFor="color">{t('CHOOSE_COLOR')}: </label>
          <CirclePicker
            className="event-color-picker"
            circleSpacing={2}
            circleSize={25}
            width="60%"
            triangle="hide"
            colors={['#B80000', '#DB3E00', '#DC8465', '#B800B1',
                     '#DE4BAB', '#D290D4', '#008B02', '#909f44',
                     '#6BD654', '#E7BE16', '#004DCF', '#006B76',
                     '#00B8AF', '#5300EB', '#66707f', '#000000' ]}
            color={color}
            onChange={onChange}
          />

        </div>
      </div>
      {description && <input type="submit" className="btn create-event-btn" onClick={(e) => onSubmit(e, description, color)} value="Create event" />}
    </form>
  </Loading>

export default translate('events')(withRouter(connect(({ ui }) => ({
    description: ui.eventForm.description,
    color: ui.eventForm.color,
    date: ui.dateSelector.date,
    loading: ui.eventForm.posting
  }),
  (dispatch, { match }) => {
    return {
      onSubmit: (e, description, color) => { e.preventDefault(); dispatch(createEvent(match.params.organisationId, { description, color })) },
      onChange: (e) => dispatch(updateEventForm(e))
    }
  }
)(Event)));



// WEBPACK FOOTER //
// ./src/components/forms/Event.js